import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useBackToClose } from "../../../utils/backToClose";

const EMPTY = { name: "", address: "", city: "", country: "", isActive: true };

function HrLocationModal({ show, onClose, onSubmit, initialData = null, isSubmitting = false, error = "" }) {
  useBackToClose(show, onClose);
  const [form, setForm] = useState(() => initialData ? { ...EMPTY, ...initialData } : { ...EMPTY });

  if (!show) return null;

  const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    onSubmit(form);
  };

  const isEdit = Boolean(initialData);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 dark:bg-black/60 p-4">
      <button type="button" aria-label="Close" onClick={onClose} className="absolute inset-0" />
      <div role="dialog" aria-modal="true" className="relative w-full max-w-lg rounded-2xl border border-app-primary bg-app-card shadow-2xl dark:shadow-black/50">
        <div className="flex items-center justify-between border-b border-app-primary px-6 py-4">
          <h3 className="text-lg font-semibold text-app-heading">{isEdit ? "Edit Location" : "Add Location"}</h3>
          <button type="button" onClick={onClose} className="rounded-lg p-2 text-app-muted transition-colors hover:bg-app-hover hover:text-app-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40">
            <FaTimes />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="px-6 py-5 space-y-4">
          {error && <p className="rounded-lg border border-app-error bg-app-error px-3 py-2 text-sm text-app-error">{error}</p>}
          <div>
            <label htmlFor="loc-name" className="mb-1 block text-sm font-medium text-app-secondary">Name <span className="text-app-error">*</span></label>
            <input id="loc-name" required value={form.name} onChange={(e) => set("name", e.target.value)}
              className="w-full rounded-lg border border-app-primary bg-app-input px-3 py-2 text-sm text-app-primary placeholder:text-app-muted outline-none transition-colors focus:border-[#2470B7] focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60 dark:focus:border-blue-400 dark:focus:ring-blue-500/20" />
          </div>
          <div>
            <label htmlFor="loc-address" className="mb-1 block text-sm font-medium text-app-secondary">Address</label>
            <input id="loc-address" value={form.address} onChange={(e) => set("address", e.target.value)}
              className="w-full rounded-lg border border-app-primary bg-app-input px-3 py-2 text-sm text-app-primary placeholder:text-app-muted outline-none transition-colors focus:border-[#2470B7] focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60 dark:focus:border-blue-400 dark:focus:ring-blue-500/20" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="loc-city" className="mb-1 block text-sm font-medium text-app-secondary">City</label>
              <input id="loc-city" value={form.city} onChange={(e) => set("city", e.target.value)}
                className="w-full rounded-lg border border-app-primary bg-app-input px-3 py-2 text-sm text-app-primary placeholder:text-app-muted outline-none transition-colors focus:border-[#2470B7] focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60 dark:focus:border-blue-400 dark:focus:ring-blue-500/20" />
            </div>
            <div>
              <label htmlFor="loc-country" className="mb-1 block text-sm font-medium text-app-secondary">Country</label>
              <input id="loc-country" value={form.country} onChange={(e) => set("country", e.target.value)}
                className="w-full rounded-lg border border-app-primary bg-app-input px-3 py-2 text-sm text-app-primary placeholder:text-app-muted outline-none transition-colors focus:border-[#2470B7] focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60 dark:focus:border-blue-400 dark:focus:ring-blue-500/20" />
            </div>
          </div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={form.isActive} onChange={(e) => set("isActive", e.target.checked)}
              className="h-4 w-4 rounded border-app-primary bg-app-input text-blue-600 focus:ring-2 focus:ring-blue-100 dark:focus:ring-blue-500/20" />
            <span className="text-sm text-app-secondary">Active</span>
          </label>
          <div className="flex justify-end gap-3 border-t border-app-primary pt-4">
            <button type="button" onClick={onClose}
              className="rounded-lg border border-app-primary px-5 py-2 text-sm font-semibold text-app-secondary transition hover:bg-app-hover hover:text-app-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40">
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting}
              className="rounded-lg border border-[#2470B7] bg-[#2470B7] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#1f5f9b] focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 disabled:cursor-not-allowed disabled:opacity-60 dark:border-blue-600 dark:bg-blue-600 dark:hover:bg-blue-500">
              {isSubmitting ? "Saving..." : isEdit ? "Save Changes" : "Add Location"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default HrLocationModal;
